
const { protocol, hostname, port } = window.location;
const BASE_URL = `${protocol}//${hostname}${port ? `:${port}` : ''}`;

//const BASE_URL = `http://localhost:8080`;


export const API = {

    BASE_URL,

    register     : BASE_URL + "/api/auth/register",
    login        : BASE_URL + "/api/auth/login",
    refresh_token        : BASE_URL + "/api/auth/refresh",
    verify2fa    : BASE_URL + "/api/auth/verify-2fa",
    logout: BASE_URL + "/api/auth/logout",
    change_password: `${BASE_URL}/api/password/change-password`,
    websocket: BASE_URL + "/ws",
    switch_user: (userId) => `${BASE_URL}/api/auth/switch-user/${userId}`,
    switch_back: `${BASE_URL}/api/auth/switch-back`,
    profile_update_me: `${BASE_URL}/api/profile/me`,
    requestReset:    BASE_URL + "/api/password/request-reset",
    verifyToken:     BASE_URL + "/api/password/verify-token",
    resetPassword:   BASE_URL + "/api/password/reset",

    get_vpos_settings:      BASE_URL + "/api/vpos-settings",
    get_vpos_by_company:    companyId => BASE_URL + `/api/vpos-settings/company/${companyId}`,

    param_vpos_settings_company: (companyId) => `${BASE_URL}/api/param-pos-settings/company/${companyId}`,
    param_vpos_settings_upsert: `${BASE_URL}/api/param-pos-settings`,
    param_vpos_settings_delete: (id) => `${BASE_URL}/api/param-pos-settings/${id}`,
    esnekpos_vpos_settings_company: (companyId) => `${BASE_URL}/api/vpos-settings/esnekpos/company/${companyId}`,
    esnekpos_vpos_settings_upsert: `${BASE_URL}/api/vpos-settings/esnekpos`,
    esnekpos_vpos_settings_delete: (id) => `${BASE_URL}/api/vpos-settings/esnekpos/${id}`,
    qnb_vpos_settings_company: (companyId) => `${BASE_URL}/api/qnb-pos-settings/company/${companyId}`,
    qnb_vpos_settings_upsert: `${BASE_URL}/api/qnb-pos-settings`,
    qnb_vpos_settings_delete: (id) => `${BASE_URL}/api/qnb-pos-settings/${id}`,
    garanti_vpos_settings_company: (companyId) => `${BASE_URL}/api/garanti-pos-settings/company/${companyId}`,
    garanti_vpos_settings_upsert: `${BASE_URL}/api/garanti-pos-settings`,
    garanti_vpos_settings_delete: (id) => `${BASE_URL}/api/garanti-pos-settings/${id}`,
    isyerimpos_vpos_settings_company: (companyId) => `${BASE_URL}/api/isyerimpos-pos-settings/company/${companyId}`,
    isyerimpos_vpos_settings_upsert: `${BASE_URL}/api/isyerimpos-pos-settings`,
    isyerimpos_vpos_settings_delete: (id) => `${BASE_URL}/api/isyerimpos-pos-settings/${id}`,
    isyerimpos_application: (companyId) => `${BASE_URL}/api/isyerimpos-application/${companyId}`,
    isyerimpos_application_defaults: (companyId) => `${BASE_URL}/api/isyerimpos-application/${companyId}/defaults`,

    bizimhesap_settings_company: (companyId) => `${BASE_URL}/api/bizimhesap-settings/company/${companyId}`,
    bizimhesap_settings_upsert: `${BASE_URL}/api/bizimhesap-settings`,
    bizimhesap_settings_delete: (id) => `${BASE_URL}/api/bizimhesap-settings/${id}`,
    bizimhesap_test_connection: (companyId) => `${BASE_URL}/api/bizimhesap-settings/company/${companyId}/test-connection`,
    bizimhesap_sync_queue: (companyId, { status = "", page = 0, size = 10 } = {}) =>
        `${BASE_URL}/api/bizimhesap-settings/company/${companyId}/sync-queue?page=${page}&size=${size}${status ? `&status=${status}` : ""}`,
    bizimhesap_sync_queue_retry: (companyId, queueId) =>
        `${BASE_URL}/api/bizimhesap-settings/company/${companyId}/sync-queue/${queueId}/retry`,

    parasut_settings_company: (companyId) => `${BASE_URL}/api/parasut-settings/company/${companyId}`,
    parasut_settings_upsert: `${BASE_URL}/api/parasut-settings`,
    parasut_settings_delete: (id) => `${BASE_URL}/api/parasut-settings/${id}`,
    parasut_connect_url: (companyId) => `${BASE_URL}/api/parasut-settings/company/${companyId}/connect-url`,
    parasut_accounts: (companyId) => `${BASE_URL}/api/parasut-settings/company/${companyId}/accounts`,
    parasut_sync_queue: (companyId, { status = "", page = 0, size = 10 } = {}) =>
        `${BASE_URL}/api/parasut-settings/company/${companyId}/sync-queue?page=${page}&size=${size}${status ? `&status=${status}` : ""}`,
    parasut_sync_queue_retry: (companyId, queueId) =>
        `${BASE_URL}/api/parasut-settings/company/${companyId}/sync-queue/${queueId}/retry`,
    active_pos_company: (companyId) => `${BASE_URL}/api/active-pos/company/${companyId}`,
    active_bank_brands: (companyId) => `${BASE_URL}/api/active-pos/company/${companyId}/active-bank-brands`,
    active_pos_migrate_brand: (companyId) =>
        `${BASE_URL}/api/active-pos/company/${companyId}/migrate-brand`,
    active_pos_orphan_summary: (companyId) =>
        `${BASE_URL}/api/active-pos/company/${companyId}/orphan-summary`,
    active_pos_migrate_pos: (companyId) =>
        `${BASE_URL}/api/active-pos/company/${companyId}/migrate-pos`,

    active_pos_refresh_brand: (companyId) =>
        `${BASE_URL}/api/active-pos/company/${companyId}/refresh-brand`,
    active_pos_standart: (companyId) =>
        `${BASE_URL}/api/active-pos/company/${companyId}/standart`,

    get_companies_names:            BASE_URL + "/api/companies/names",
    get_account_groups_by_company:  cid     => BASE_URL + `/api/account-groups/by-company/${cid}`,
    import_excel:      BASE_URL + "/api/v1/accounts/import-excel",

    // user management
    create_user:        BASE_URL + "/api/admin/users",
    get_users_page:     (page, size, term) => {
        let url = `${BASE_URL}/api/admin/users?page=${page}&size=${size}`;
        if (term) url += `&searchTerm=${encodeURIComponent(term)}`;
        return url;
    },

    bin_detail:       (bin, cid) => BASE_URL + `/api/payments/bin-detail?bin=${bin}&companyId=${cid}`,
    /** Taksit tabloları */
    installments:                  BASE_URL + "/api/account-groups/me",
    //all_installments:                  BASE_URL + "/api/account-groups/all",

    auth_me               : BASE_URL + "/api/auth/me",
    complete_onboarding   : BASE_URL + "/api/auth/me/onboarding-complete",
    vpos_settings_upsert  : BASE_URL + "/api/vpos-settings",

    // dinamik factory’ler
    company_settings      : companyId      => `${BASE_URL}/api/admin/companies/settings/${companyId}`,
    company_logo          : companyId      => `${BASE_URL}/api/admin/companies/${companyId}/logo`,
    company_favicon       : companyId      => `${BASE_URL}/api/admin/companies/${companyId}/favicon`,
    vpos_settings_company : companyId      => `${BASE_URL}/api/vpos-settings/company/${companyId}`,
    groups_by_company     : companyId      => `${BASE_URL}/api/account-groups/by-company/${companyId}`,
    /**
     * Sayfalı taksit grubu listesi. `companyId` YALNIZ süper adminde etkilidir;
     * gönderilmezse süper admin tüm firmaların gruplarını görür, diğer roller
     * backend tarafından kendi firmalarına kısıtlanır.
     */
    account_groups_page   : ({ page = 0, size = 10, searchTerm, companyId, sort } = {}) => {
        const params = new URLSearchParams({ page, size });
        if (searchTerm) params.append("searchTerm", searchTerm);
        if (companyId) params.append("companyId", companyId);
        if (sort) params.append("sort", sort);
        return `${BASE_URL}/api/account-groups?${params.toString()}`;
    },
    group_save            : (groupId=null) => groupId
        ? `${BASE_URL}/api/account-groups/${groupId}`
        : `${BASE_URL}/api/account-groups`,

    final_rates: BASE_URL + "/api/companies/final-rates",

    get_accounts_id_name: `${BASE_URL}/api/v1/accounts/id-name`,
    account_summary: accountId => `${BASE_URL}/api/v1/accounts/${accountId}/summary`,



    admin_companies_list : BASE_URL + "/api/admin/companies",
    admin_company        : id => `${BASE_URL}/api/admin/companies/${id}`,

    admin_users_list : BASE_URL + "/api/admin/users",
    admin_user       : id => `${BASE_URL}/api/admin/users/${id}`,

    getInstallmentRates: companyId => `${BASE_URL}/api/admin/companies/installment-rates/${companyId}?provider=PAYTR`,
    get_company_contract: BASE_URL + "/api/companies/contract",

    contract_cancel_return_privacy : (companyId) =>
        `${BASE_URL}/api/companies/contract/cancellation-return-privacy` +
        (companyId ? `?companyId=${companyId}` : ""),

    contract_personal_data : (companyId) =>
        `${BASE_URL}/api/companies/contract/personal-data-policy` +
        (companyId ? `?companyId=${companyId}` : ""),

    contract_service_agreement : (companyId) =>
        `${BASE_URL}/api/companies/contract/service-agreement` +
        (companyId ? `?companyId=${companyId}` : ""),

    get_sample_contract: (type,companyId) =>
        `${BASE_URL}/api/companies/sample-contract?type=${type}&companyId=${companyId}`,

    updateGroup: id => `${BASE_URL}/api/account-groups/${id}`,
    deleteGroup: id => `${BASE_URL}/api/account-groups/${id}`,
    createGroup: () => `${BASE_URL}/api/account-groups`,

    // Paket (abonelik) ödemesinde gösterilecek taksit grubunu aç/kapat.
    // Sistem genelinde tek grup açık olabilir; açmak öncekini backend'de düşürür.
    setSubscriptionGroup: (id, enabled) =>
        `${BASE_URL}/api/account-groups/${id}/subscription-group?enabled=${enabled}`,

    process_payment: BASE_URL + "/api/payments/instant",
    create_instant_link: BASE_URL + "/api/payments/generate-link",
    instant_link_info: BASE_URL + "/api/payments/instant-link",
    payment_links_share: BASE_URL + "/api/payment-links-share",
    // instantuid: ödeme linkinin token'ı/id'si. Verilirse backend BIN'i linkin
    // firmasının kendi POS sağlayıcısına sorar; verilmezse platform hesabına düşer.
    query_bin_no_auth: (bin, linkId) => BASE_URL + `/api/payments/lookup/${bin}`
        + (linkId ? `?instantuid=${encodeURIComponent(linkId)}` : ''),
    payment_links_list: BASE_URL + "/api/payments/links",
    payment_links_stats: BASE_URL + "/api/payments/links/stats",
    payments_history: BASE_URL + "/api/payments/history",
    // Tekil ödeme detayı — liste ile aynı DTO. Tam detay sayfası doğrudan açıldığında
    // (yenileme, paylaşılan link, İade Geçmişi'nden geçiş) veri buradan gelir.
    payment_detail_by_id: id => `${BASE_URL}/api/payments/${id}`,
    // Onaylanan sözleşme metni — detaydan ayrı uçta; metin uzun olabildiği için
    // yalnızca sözleşme kartı açıldığında çekilir.
    payment_contract: id => `${BASE_URL}/api/payments/${id}/contract`,
    payment_accounted: id => `${BASE_URL}/api/payments/${id}/accounted`,
    payment_bulk_accounted: BASE_URL + "/api/payments/bulk-accounted",
    // İade geçmişi (okuma) — sağlayıcıdan bağımsız; PayTR/Garanti/İşyerimPOS tek modelden döner.
    payment_refunds: BASE_URL + "/api/payment-refunds",
    payment_refund_detail: paymentId => `${BASE_URL}/api/payment-refunds/payment/${paymentId}`,

    payment_refund: id => `${BASE_URL}/api/payments/${id}/refund`,
    payment_refund_garanti: id => `${BASE_URL}/api/payments/${id}/garanti-refund`,
    payment_refund_isyerimpos: id => `${BASE_URL}/api/payments/${id}/isyerimpos-refund`,
    payment_receipt_email: id => `${BASE_URL}/api/payments/${id}/receipt/email`,
    markLinkClicked: id => `${BASE_URL}/api/payments/links/clicked/${id}`,
    payment_link_status: (id, status) => `${BASE_URL}/api/payments/payment-links/${id}/status?status=${status}`,
    payment_link_rotate_token: id => `${BASE_URL}/api/payments/payment-links/${id}/rotate-token`,
    // Yumuşak silme: kayıt ve tahsilat geçmişi backend'de korunur.
    payment_link_delete: id => `${BASE_URL}/api/payments/payment-links/${id}`,
    mark_payment_fallback:   merchantOid => BASE_URL + `/api/payments/mark-fallback/${merchantOid}`,
    check_payment_fallback:  merchantOid => BASE_URL + `/api/payments/check-fallback/${merchantOid}`,




    // Account CRUD operations
    accounts_list     : BASE_URL + "/api/v1/accounts",                    // GET - sayfalı liste
    create_account    : BASE_URL + "/api/v1/accounts",                    // POST - yeni cari oluştur
    account           : id => `${BASE_URL}/api/v1/accounts/${id}`,        // GET/PUT/DELETE - cari detay/güncelle/sil
    accounts_all      : BASE_URL + "/api/v1/accounts/all",               // GET - tüm cariler (SUPER_ADMIN)
    accounts_me       : BASE_URL + "/api/v1/accounts/me",                // GET - kendi carilerim
    accounts_by_company: companyId => `${BASE_URL}/api/v1/accounts/by-company/${companyId}`, // GET - şirkete göre cariler


    // istatistik endpointleri
    get_dashboard_statistics: (companyId, startDate, endDate) => {
        let url = `${BASE_URL}/api/payments/dashboard`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        return params.toString() ? `${url}?${params.toString()}` : url;
    },

    // POS Rapor — kök ekran (POS sağlayıcı listesi + KPI / trend / dağılım)
    get_pos_analytics: (period, startDate, endDate) => {
        let url = `${BASE_URL}/api/admin/pos-analytics`;
        const params = new URLSearchParams();
        if (period) params.append('period', period);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        return params.toString() ? `${url}?${params.toString()}` : url;
    },

    // POS Rapor hiyerarşisi: POS → Firmalar → Firma → Cariler
    get_pos_companies: (provider, { period, startDate, endDate, page, size, companyId, sort, direction, ...filters } = {}) => {
        const params = new URLSearchParams();
        if (period) params.append('period', period);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (page != null) params.append('page', page);
        if (size != null) params.append('size', size);
        if (companyId) params.append('companyId', companyId);
        // Sıralama sayfalamadan önce tüm kapsama uygulanır (bkz. PosTableSorter)
        if (sort) params.append('sort', sort);
        if (direction) params.append('direction', direction);
        // Gelişmiş filtreleme (backend'de gruplama sonrası, sayfalamadan önce uygulanır)
        ['search', 'minTransactionCount', 'maxTransactionCount', 'minGrossAmount',
         'maxGrossAmount', 'minNetAmount', 'maxNetAmount'].forEach((k) => {
            if (filters[k] !== undefined && filters[k] !== null && filters[k] !== '') {
                params.append(k, filters[k]);
            }
        });
        const url = `${BASE_URL}/api/admin/pos-analytics/${provider}/companies`;
        return params.toString() ? `${url}?${params.toString()}` : url;
    },
    get_pos_company_accounts: (provider, companyId, { period, startDate, endDate, page, size, accountId, sort, direction, ...filters } = {}) => {
        const params = new URLSearchParams();
        if (period) params.append('period', period);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (page != null) params.append('page', page);
        if (size != null) params.append('size', size);
        if (accountId) params.append('accountId', accountId);
        if (sort) params.append('sort', sort);
        if (direction) params.append('direction', direction);
        // Gelişmiş filtreleme (backend'de gruplama sonrası, sayfalamadan önce uygulanır)
        ['search', 'minTransactionCount', 'maxTransactionCount', 'minGrossAmount',
         'maxGrossAmount', 'minNetAmount', 'maxNetAmount'].forEach((k) => {
            if (filters[k] !== undefined && filters[k] !== null && filters[k] !== '') {
                params.append(k, filters[k]);
            }
        });
        const url = `${BASE_URL}/api/admin/pos-analytics/${provider}/companies/${companyId}/accounts`;
        return params.toString() ? `${url}?${params.toString()}` : url;
    },
    // Seçili kapsamın (POS / POS+firma / POS+firma+cari) özet KPI'ları
    get_pos_scope_summary: (provider, { companyId, accountId, period, startDate, endDate } = {}) => {
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        if (accountId) params.append('accountId', accountId);
        if (period) params.append('period', period);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        const url = `${BASE_URL}/api/admin/pos-analytics/${provider}/summary`;
        return params.toString() ? `${url}?${params.toString()}` : url;
    },

    // POS Mutabakat (cari bazlı) ve İşlem detayı — companyId/accountId ile kapsam daraltılır
    get_pos_reconciliation: (provider, startDate, endDate, companyId) => {
        const params = new URLSearchParams();
        params.append('provider', provider);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (companyId) params.append('companyId', companyId);
        return `${BASE_URL}/api/admin/pos-analytics/reconciliation?${params.toString()}`;
    },
    get_pos_transactions: (provider, startDate, endDate, companyId, accountId, opts = {}) => {
        const params = new URLSearchParams();
        params.append('provider', provider);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (companyId) params.append('companyId', companyId);
        if (accountId) params.append('accountId', accountId);
        // Sayfalama + sıralama + filtreler: hepsi sunucuda, sayfalamadan önce uygulanır
        const { page, size, sort, direction, ...filters } = opts;
        if (page != null) params.append('page', page);
        if (size != null) params.append('size', size);
        if (sort) params.append('sort', sort);
        if (direction) params.append('direction', direction);
        ['search', 'minAmount', 'maxAmount', 'minValorDate', 'maxValorDate',
         'installmentType', 'rateIncreased', 'cardType'].forEach((k) => {
            if (filters[k] !== undefined && filters[k] !== null && filters[k] !== '') {
                params.append(k, filters[k]);
            }
        });
        return `${BASE_URL}/api/admin/pos-analytics/transactions?${params.toString()}`;
    },

    // POS Valör (T+X) ayarları
    pos_valor_company: (companyId) => `${BASE_URL}/api/pos-valor/company/${companyId}`,
    // Komisyon hakediş oranları (firma + sanal POS) — yalnız süper admin
    pos_earning_company: (companyId) => `${BASE_URL}/api/pos-earning/company/${companyId}`,

    // Resmî tatil takvimi (valör hesabında atlanan günler) — yalnız süper admin
    public_holidays: (year) => year != null
        ? `${BASE_URL}/api/admin/public-holidays?year=${year}`
        : `${BASE_URL}/api/admin/public-holidays`,
    public_holiday_delete: (date) => `${BASE_URL}/api/admin/public-holidays/${date}`,
    public_holidays_bulk: () => `${BASE_URL}/api/admin/public-holidays/bulk`,
    public_holiday_years: () => `${BASE_URL}/api/admin/public-holidays/years`,
    public_holiday_year_confirm: (year) => `${BASE_URL}/api/admin/public-holidays/years/${year}/confirm`,
    // Anlaşılan (baz) komisyon oranı
    active_pos_baselines: (companyId) => `${BASE_URL}/api/active-pos/company/${companyId}/baselines`,

    // En çok ödeme yapanlar için istatistikler
    get_top_accounts: (companyId, startDate, endDate) => {
        let url = `${BASE_URL}/api/payments/top-accounts`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        return params.toString() ? `${url}?${params.toString()}` : url;
    },

    // API.js dosyasında
    get_time_series: (companyId, startDate, endDate) => {
        let url = `${BASE_URL}/api/payments/time-series`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        if (startDate) params.append('period', startDate);
        if (endDate) params.append('endDate', endDate);
        return params.toString() ? `${url}?${params.toString()}` : url;
    },

    get_monthly_statistics: (companyId, months = 12) => {
        let url = `${BASE_URL}/api/payments/monthly`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        params.append('months', months);
        return `${url}?${params.toString()}`;
    },

    get_recent_payments: (companyId, limit = 10) => {
        let url = `${BASE_URL}/api/payments/recent-payments`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        params.append('limit', limit);
        return `${url}?${params.toString()}`;
    },

    get_payment_distribution: (companyId, startDate, endDate) => {
        let url = `${BASE_URL}/api/payments/payment-distribution`;
        const params = new URLSearchParams();
        if (companyId) params.append('companyId', companyId);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        return params.toString() ? `${url}?${params.toString()}` : url;
    },



    get_company_info_by_domain: BASE_URL +'/api/companies/info/by-domain',
    get_company_logo:  BASE_URL +'/api/companies/logo',
    get_company_favicon:  BASE_URL +'/api/companies/favicon',
    companies_list: BASE_URL + "/api/admin/companies/list",

    scheduled_reports_list: `${BASE_URL}/api/scheduled-reports`,
    scheduled_reports_detail: (id) => `${BASE_URL}/api/scheduled-reports/${id}`,
    // Raporu e-posta beklemeden görüntüleme / indirme uçları
    scheduled_report_preview: (id) => `${BASE_URL}/api/scheduled-reports/${id}/preview`,
    scheduled_report_export: (id) => `${BASE_URL}/api/scheduled-reports/${id}/export`,

    notifications: BASE_URL + "/api/notifications",
    notifications_unread_count: BASE_URL + "/api/notifications/unread-count",
    notifications_mark_read: BASE_URL + "/api/notifications", // /{id}/read
    notifications_mark_read_all: BASE_URL + "/api/notifications/read-all",
    notifications_mark_read_bulk: BASE_URL + "/api/notifications/read-bulk",

    current_contract: BASE_URL + "/api/contracts/current/download",
    status_contract: BASE_URL + "/api/contracts/status",
    sign_contract: BASE_URL + "/api/contracts/sign",
    companyLatest_contract: BASE_URL + "/api/contracts/company/latest",


    add_debt: BASE_URL + "/api/v1/accounts/debt",
    add_receipt: BASE_URL + "/api/v1/accounts/receipt",
    remove_debt_manual: BASE_URL + "/api/v1/accounts/debt/remove",
    debt_reminder_trigger: `${BASE_URL}/api/account-debt-reminders/trigger`,
    debt_reminder_schedule_upsert: `${BASE_URL}/api/account-debt-reminders/schedules`,
    get_debt_reminder_schedule: (accountId) =>
        `${BASE_URL}/api/account-debt-reminders/schedules/${accountId}`,
    delete_debt_reminder_schedule: (accountId) =>
        `${BASE_URL}/api/account-debt-reminders/schedules/${accountId}`,
    debt_reminder_accounts: (sortBy = 'balance', sortDir = 'asc') =>
        `${BASE_URL}/api/account-debt-reminders/accounts?sortBy=${sortBy}&sortDir=${sortDir}`,
    one_time_reminder_create: `${BASE_URL}/api/account-debt-reminders/one-time`,
    one_time_reminder_list: (accountId) =>
        `${BASE_URL}/api/account-debt-reminders/one-time/${accountId}`,
    one_time_reminder_cancel: (id) =>
        `${BASE_URL}/api/account-debt-reminders/one-time/${id}`,
    account_reconciliation_pdf_download: `${BASE_URL}/api/account-reconciliations/pdf/download`,
    account_reconciliation_pdf_email: `${BASE_URL}/api/account-reconciliations/pdf/email`,
    account_movements: (accountId, page, size, filters = {}) => {
        const params = new URLSearchParams();
        params.set("page", page);
        params.set("size", size);
        if (filters.movementType) params.set("movementType", filters.movementType);
        if (filters.dueDateFilter) params.set("dueDateFilter", filters.dueDateFilter);
        if (filters.startDate) params.set("startDate", filters.startDate);
        if (filters.endDate) params.set("endDate", filters.endDate);
        return `${BASE_URL}/api/v1/accounts/${accountId}/movements?${params.toString()}`;
    },
    due_tracking_movements: (page, size, filters = {}) => {
        const params = new URLSearchParams();
        params.set("page", page);
        params.set("size", size);
        if (filters.movementType) params.set("movementType", filters.movementType);
        if (filters.dueDateFilter) params.set("dueDateFilter", filters.dueDateFilter);
        if (filters.sortBy) params.set("sortBy", filters.sortBy);
        if (filters.sortDir) params.set("sortDir", filters.sortDir);
        if (filters.startDate) params.set("startDate", filters.startDate);
        if (filters.endDate) params.set("endDate", filters.endDate);
        return `${BASE_URL}/api/v1/accounts/movements/due-tracking?${params.toString()}`;
    },
    remove_movement: movementId => `${BASE_URL}/api/v1/accounts/movement/${movementId}`,
    // Borç ödeme detayı (kısmi ödeme geçmişi) — Vade Takibi Detay butonu
    debt_payment_detail: debtId => `${BASE_URL}/api/v1/accounts/movements/${debtId}/payments`,
    get_cumulative_balance: `${BASE_URL}/api/v1/accounts/cumulative-balance`,

    // Registration Requests (SUPER_ADMIN)
    admin_registrations_list: BASE_URL + "/api/admin/registrations",
    admin_registration: id => `${BASE_URL}/api/admin/registrations/${id}`,
    admin_registration_review: id => `${BASE_URL}/api/admin/registrations/${id}/review`,

    // Destek talepleri (ticket) — kullanıcı yüzeyi
    tickets_list: BASE_URL + "/api/tickets",
    tickets_summary: BASE_URL + "/api/tickets/summary",
    ticket: id => `${BASE_URL}/api/tickets/${id}`,
    ticket_reply: id => `${BASE_URL}/api/tickets/${id}/messages`,
    ticket_close: id => `${BASE_URL}/api/tickets/${id}/close`,
    ticket_attachment: (ticketId, attachmentId) =>
        `${BASE_URL}/api/tickets/${ticketId}/attachments/${attachmentId}`,
    // Görsel gösterimi: içerik base64 (data URI) olarak gelir, doğrudan <img src> ile basılır.
    ticket_attachment_base64: (ticketId, attachmentId) =>
        `${BASE_URL}/api/tickets/${ticketId}/attachments/${attachmentId}/base64`,
    // Destek talepleri — personel (SUPER_ADMIN)
    admin_tickets_list: BASE_URL + "/api/admin/tickets",
    admin_ticket: id => `${BASE_URL}/api/admin/tickets/${id}`,
    admin_ticket_reply: id => `${BASE_URL}/api/admin/tickets/${id}/messages`,
    admin_ticket_update: id => `${BASE_URL}/api/admin/tickets/${id}`,
    admin_tickets_summary: BASE_URL + "/api/admin/tickets/summary",
    admin_ticket_assignees: BASE_URL + "/api/admin/tickets/assignees",
    admin_ticket_assign: id => `${BASE_URL}/api/admin/tickets/${id}/assign`,

    // Subscription - COMPANY_ADMIN
    subscription_plans: BASE_URL + "/api/subscriptions/plans",
    subscription_current: BASE_URL + "/api/subscriptions/current",
    subscription_invoice_info: BASE_URL + "/api/subscriptions/invoice-info",
    subscription_calculate: BASE_URL + "/api/subscriptions/calculate",
    subscription_validate_coupon: BASE_URL + "/api/subscriptions/validate-coupon",
    subscription_purchase: BASE_URL + "/api/subscriptions/purchase",
    // Paket ödemesinde gösterilecek taksit seçenekleri. Tahsilatı platform yaptığı
    // için oranlar ödeyen firmadan değil, işaretli tek taksit grubundan gelir.
    subscription_installment_group: BASE_URL + "/api/subscriptions/installment-group",
    subscription_history: BASE_URL + "/api/subscriptions/history",
    subscription_invoice: (id) => BASE_URL + "/api/subscriptions/invoice/" + id,
    subscription_upgrade_preview: BASE_URL + "/api/subscriptions/upgrade/preview",
    subscription_upgrade: BASE_URL + "/api/subscriptions/upgrade",
    subscription_downgrade: BASE_URL + "/api/subscriptions/downgrade",
    // Subscription - SUPER_ADMIN
    admin_subscription_plans: BASE_URL + "/api/admin/subscriptions/plans",
    admin_subscription_plan: id => `${BASE_URL}/api/admin/subscriptions/plans/${id}`,
    admin_coupons: BASE_URL + "/api/admin/subscriptions/coupons",
    admin_coupon: id => `${BASE_URL}/api/admin/subscriptions/coupons/${id}`,
    admin_coupon_usages: id => `${BASE_URL}/api/admin/subscriptions/coupons/${id}/usages`,
    admin_price_overrides: BASE_URL + "/api/admin/subscriptions/price-overrides",
    admin_price_override: id => `${BASE_URL}/api/admin/subscriptions/price-overrides/${id}`,
    admin_subscription_assign: BASE_URL + "/api/admin/subscriptions/assign",
    admin_subscription_upgrade_preview: (companyId, targetPlanId) =>
        `${BASE_URL}/api/admin/subscriptions/company/${companyId}/upgrade-preview?targetPlanId=${targetPlanId}`,
    admin_subscription_refund: BASE_URL + "/api/admin/subscriptions/refund",
    admin_subscription_dashboard_stats: BASE_URL + "/api/admin/subscriptions/dashboard-stats",
    admin_subscription_all: BASE_URL + "/api/admin/subscriptions/all",
    admin_subscription_company_settings: BASE_URL + "/api/admin/subscriptions/company-settings",
    admin_subscription_company_history: companyId => `${BASE_URL}/api/admin/subscriptions/company/${companyId}/history`,
    // Paket özellik kataloğu + firma bazlı paket görünürlüğü (V93)
    admin_plan_features: BASE_URL + "/api/admin/subscriptions/plan-features",
    admin_plan_integrations: BASE_URL + "/api/admin/subscriptions/plan-integrations",
    admin_company_plan_visibility: companyId => `${BASE_URL}/api/admin/subscriptions/company-plan-visibility/${companyId}`,
    admin_company_plan_visibility_save: BASE_URL + "/api/admin/subscriptions/company-plan-visibility",
    // Firmanın kendi paketindeki açık özellikler + tahsilat limiti kullanımı
    my_plan_features: BASE_URL + "/api/subscriptions/my-features",
    plan_feature_catalog: BASE_URL + "/api/subscriptions/plan-features",
    plan_integration_catalog: BASE_URL + "/api/subscriptions/plan-integrations",
    my_plan_integrations: BASE_URL + "/api/subscriptions/my-integrations",
    my_connected_integrations: BASE_URL + "/api/subscriptions/my-integrations/connected",
    plan_trial_status: BASE_URL + "/api/subscriptions/plan-trial",
    plan_trial_start: (planId) => `${BASE_URL}/api/subscriptions/plan-trial/${planId}`,
    my_collection_usage: BASE_URL + "/api/subscriptions/collection-usage",
    // Paket dışı özelliklerin ücretsiz denemesi (V99)
    feature_trials: BASE_URL + "/api/subscriptions/feature-trials",
    feature_trial_start: featureCode => `${BASE_URL}/api/subscriptions/feature-trials/${featureCode}`,
    subscription_check_payment: merchantOid => `${BASE_URL}/api/payments/check-fallback/${merchantOid}`,
    subscription_mark_fallback: merchantOid => `${BASE_URL}/api/payments/mark-fallback/${merchantOid}`,

    // Panel üst duyuru şeridi (V108)
    announcements_active: BASE_URL + "/api/announcements/active",
    announcements: BASE_URL + "/api/announcements",
    announcement_detail: id => `${BASE_URL}/api/announcements/${id}`,

};
